import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import { Box } from '@mentimeter/ragnar-ui/box';
import { getNinePointLayoutProperties } from '../../shared/utils/getNinePointLayoutProperties';
import { TitleSection } from '../../shared/components/title-section/TitleSection';

export function MetadataPresentation() {
  const { useQuestion } = usePresentationContext();
  const { question, question_styled, title_meta: meta, layout } = useQuestion();

  const { textAlign, alignItems } = getNinePointLayoutProperties(layout);

  return (
    <Box
      width="100%"
      height="100%"
      alignItems="center"
      justifyContent="center"
      data-testid="metadata-container"
      p={4}
    >
      <TitleSection
        title={question}
        styledTitle={question_styled}
        label={meta}
        fontSizeOffset={layout?.font_size_offset}
        textAlign={textAlign}
        alignItems={alignItems}
        mb="space4"
        showTextSizeDropdown={true}
      />
    </Box>
  );
}
